import * as React from "react";

import { MENU, REMOVE } from "../../../Constants";
import { OutotecIcons } from "../../General/Icons/";

interface SideNavActionsProps {
    collapsed: boolean;

    onCollapse(): any;
}

const SideNavActions: React.FC<SideNavActionsProps> = (props) => {
    return (
        <div className="SideNavActions">
            {!props.collapsed && (
                <span
                    onClick={() => props.onCollapse()}
                    className="SideNavActions__CloseLeft"
                >
                    Close
                </span>
            )}

            {!props.collapsed && (
                <span
                    onClick={() => props.onCollapse()}
                    className="SideNavActions__CloseRight"
                >
                    <OutotecIcons type={REMOVE} />
                </span>
            )}

            {props.collapsed && (
                <span
                    onClick={() => props.onCollapse()}
                    className="SideNavActions__Menu"
                >
                    <OutotecIcons type={MENU} />
                </span>
            )}
        </div>
    );
};

export default SideNavActions;
